import { render, staticRenderFns } from "./BoardEvent.vue?vue&type=template&id=bfa3b70c&scoped=true"
import script from "./BoardEvent.vue?vue&type=script&lang=js"
export * from "./BoardEvent.vue?vue&type=script&lang=js"
import style0 from "./BoardEvent.vue?vue&type=style&index=0&id=bfa3b70c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa3b70c",
  null
  
)

export default component.exports